<pp-button
  data-test="editReminderButton"
  class="reminderModal__actionButton"
  ppStyle="secondary"
  ppSize="wide"
  (ppAction)="toggleEdit()"
  [id]="buttonId"
  >
  <span class="reminderModal__editButtonContent">
    {{ 'edit' | ppTranslate }}

    @if (ppIsSeries) {
      <pp-icon
      [ppSrc]="
        dropdown.visible && dropdown.buttonId === buttonId
          ? EIconPath.ICON_MISC_UP_ARROW_14
          : EIconPath.ICON_MISC_DOWN_ARROW_14
      "
        ppColor="grey-400"
        ppClass="setSize14"
      ></pp-icon>
    }
  </span>
</pp-button>
